import axios from '@/axios.js';
import state from './state';

export default {
    specialists({ commit, dispatch }, slug)  {
        state.specialistsLoading = true;
        
        let path;
        if(slug)
            path = '/specialists?slug='+slug;
        else
            path = '/specialists';

        axios.get(path)
        .then(function (response) {
            commit('SPECIALISTS', response);
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true})
        });
    },
    categories({ commit, dispatch }) {
        axios.get('/global/categories')
        .then(function (response) {
            commit('CATEGORIES', response);
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true})
        });
    },
}
